// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__uJ_G0","label":"styles_label__DbML7","icon":"styles_icon__mkYp_"};